import Service from "../service";

const DropDown ={
    getViolenec1(){
        return Service.get("/login");
    }
}
export default DropDown